import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import parse from 'html-react-parser';
import styled from 'styled-components';

import { IEX_STATE_CODES } from '../../../constants/configs/states';

interface ISidebarProps {
    heading: string;
    steps: string[];
    stateCode: string;
}

const StyledFlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-top: 14px;
`;

const StyledDiv = styled.div<{ $stateCode?: string }>`
    .sidebar_steps {
        padding: 10px;
    }

    ${({ theme, $stateCode }) =>
        $stateCode === IEX_STATE_CODES.MN
            ? `
            h3 {
                padding: 10px;
                min-height: 40px;
                background: ${theme.sidebar_header_bg};
                border-radius: 8px 8px 0 0;
                margin-bottom: 0;
            }`
            : `
                height: fit-content;
                padding-bottom: 20px;
                border: 1px solid ${theme.gray8};
                background-color: ${theme.defaultWhite};
                border-radius: 8px;
                padding: 24px 24px 32px 24px;
                .sidebar_steps{
                    padding-left: 16px;
                    padding-right: 16px;
                    display: flex;
                    flex-direction: column;
                    gap: 30px;
                    padding-top: 14px;
                }`}
`;

const SideBar = ({ heading, steps, stateCode }: ISidebarProps) => {
    const intl = useIntl();
    return (
        <StyledDiv $stateCode={stateCode}>
            <h3>
                <FormattedMessage id={heading} />
            </h3>
            <StyledFlexContainer className="sidebar_steps">
                {steps.map(step => (
                    <div key={Math.random()}>{parse(intl.formatMessage({ id: step }))}</div>
                ))}
            </StyledFlexContainer>
        </StyledDiv>
    );
};

export default SideBar;
